import { combineReducers } from 'redux';

import timecard from './timecard';

export default combineReducers({
  timecard,
});
